import { useEffect, useState } from "react";
import { Select } from "antd";
import { api, isAdminRole } from "../../services/apiClient";

export default function PromptUserFilter({ value, onChange }) {
  const [users, setUsers] = useState([]);
  const isAdmin = isAdminRole();

  useEffect(() => {
    if (!isAdmin) return;
    api.get("/api/users/options").then((items) => setUsers(items || [])).catch(() => setUsers([]));
  }, [isAdmin]);

  if (!isAdmin) return null;
  return (
    <Select
      className="prompt-user-filter"
      value={value || "ALL"}
      onChange={(nextValue) => onChange(nextValue === "ALL" ? null : nextValue)}
      options={[
        { value: "ALL", label: "Tất cả người dùng" },
        ...users.map((user) => ({ value: user.id, label: `${user.username || user.email} (${user.email})` })),
      ]}
    />
  );
}
